import { CompetitorData } from "../DataProvider";
import {
  getArrivalColor,
  getGateColour,
  shortenName,
} from "../../../utils/helper-funcs";
import { getFlag } from "../../../images/flags/getFlag";
import { Wreath } from "./Wreath";

interface ResultSlipProps {
  competitor: CompetitorData;
  compact?: boolean;
}

export function ResultSlip({ competitor, compact = false }: ResultSlipProps) {
  const colour = getArrivalColor(competitor.arrival);
  return (
    <li className={`flex items-center flex-1 w-full ${compact ? 'gap-1' : 'gap-2'}`}>
      <Wreath arrival={competitor.arrival} compact={compact} />
      <div
        className={`flex items-center justify-between flex-1 ${compact ? 'h-full pr-2 border-l-4' : 'h-full pr-4 border-l-8'}`}
        style={{
          borderColor: getGateColour(competitor.cardinal),
          backgroundColor:
            competitor.arrival <= 3 ? `${colour}50` : "transparent", // 50% opacity to colour
        }}
      >
        <div className={`flex items-center flex-1 ${compact ? 'h-4 gap-1' : 'h-6 gap-2 md:h-12 lg:gap-6'}`}>
          <div className={`flex items-center justify-center ${compact ? 'gap-0.5 py-0.5 pl-2' : 'gap-1 py-1 pl-3 lg:gap-3 lg:px-2'}`}>
            <div className={`flex items-center justify-center ${compact ? 'w-4' : 'w-6'}`}>
              <span className={`italic font-extrabold text-foreground ${compact ? 'text-sm md:text-base lg:text-xl' : 'md:text-xl lg:text-2xl'}`}>
                {competitor.cardinal}
              </span>
            </div>
            <div className={`${compact ? 'w-3 h-3 md:w-4 md:h-4 lg:w-8 lg:h-8' : 'w-4 h-4 md:w-6 md:h-6 lg:w-12 lg:h-12'}`}>
              <img
                src={getFlag(competitor.name)}
                alt=""
                className="object-contain w-full h-full"
              />
            </div>
          </div>
          <span className={`italic ${compact ? 'text-xs md:text-sm lg:text-base truncate max-w-[120px] md:max-w-[150px] lg:max-w-[200px]' : 'lg:text-2xl'}`}>
            {shortenName(competitor.name)}
          </span>
        </div>
        {/* <div className={`flex justify-center items-center ${compact ? 'lg:w-[80px] w-10' : 'lg:w-[120px]'}`}>
          <span className={`italic font-extrabold lg:text-foreground ${compact ? 'text-xs md:text-sm lg:text-xl' : 'text-sm md:text-base lg:text-2xl'}`}>
            {competitor.oddsWin.toFixed(2)}
          </span>
        </div> */}
      </div>
    </li>
  );
}